import { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, FileText, Download, Shield, Lock, Award, Scale } from 'lucide-react';

const COLORS = {
  primary: '#22c55e',
  primaryDark: '#16a34a',
  dark: '#0f172a',
  gray: '#64748b',
  grayLight: '#94a3b8',
  white: '#ffffff',
  bg: '#f8fafc'
};

// URLs for PDF documents
const LICENSE_PDFS = {
  'license-broker': '/documents/license-broker.pdf',
  'license-dealer': '/documents/license-dealer.pdf',
  'registration': '/documents/certificate-registration.pdf'
};

const documents = [
  {
    id: 'license-broker',
    title: 'Лицензия на брокерскую деятельность',
    icon: <Award size={24} />,
    isPdf: true,
    content: ``
  },
  {
    id: 'license-dealer',
    title: 'Лицензия на дилерскую деятельность',
    icon: <Award size={24} />,
    isPdf: true,
    content: ``
  },
  {
    id: 'registration',
    title: 'Свидетельство о государственной регистрации',
    icon: <FileText size={24} />,
    isPdf: true,
    content: ``
  },
  {
    id: 'aml',
    title: 'Политика AML/KYC',
    icon: <Shield size={24} />,
    content: `
ПОЛИТИКА
противодействия легализации (отмыванию) доходов, 
полученных преступным путём, и финансированию терроризма
(AML/KYC Policy)

ОсОО «ФВА Финанс»
Редакция от 01.01.2024

1. ОБЩИЕ ПОЛОЖЕНИЯ

1.1. Настоящая Политика разработана в соответствии с:
- Законом КР "О противодействии финансированию терроризма и легализации 
  (отмыванию) доходов, полученных преступным путём"
- Законом КР "О виртуальных активах"
- Рекомендациями ФАТФ (Группа разработки финансовых мер борьбы 
  с отмыванием денег)

1.2. Цель Политики - предотвращение использования услуг Компании 
для легализации доходов, полученных преступным путём, и финансирования 
терроризма.

2. ИДЕНТИФИКАЦИЯ КЛИЕНТОВ (KYC)

2.1. Базовая верификация (лимит до 100 000 сом/месяц):
- Номер телефона
- Адрес электронной почты

2.2. Расширенная верификация (без лимита):
- Документ, удостоверяющий личность (паспорт, ID-карта)
- Селфи с документом
- Подтверждение адреса проживания

3. МОНИТОРИНГ ТРАНЗАКЦИЙ

3.1. Компания осуществляет мониторинг всех транзакций на предмет:
- Необычно крупных операций
- Частых операций на небольшие суммы (структурирование)
- Операций с высокорисковыми юрисдикциями
- Несоответствия профилю клиента

3.2. Подозрительные транзакции передаются в Государственную службу 
финансовой разведки КР.

4. ХРАНЕНИЕ ДАННЫХ

4.1. Данные о клиентах и транзакциях хранятся не менее 5 лет 
после завершения деловых отношений.

5. ОБУЧЕНИЕ ПЕРСОНАЛА

5.1. Все сотрудники проходят обязательное обучение по вопросам 
AML/KYC не реже одного раза в год.

6. ОТВЕТСТВЕННОСТЬ

6.1. Ответственный сотрудник по AML/KYC: Compliance Officer
6.2. Контакт: support@polytechex.com

Дата утверждения: 01.01.2024
Директор: Уткина Е.А. ________________
    `
  },
  {
    id: 'terms',
    title: 'Пользовательское соглашение',
    icon: <FileText size={24} />,
    content: `
ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ
сервиса PolyTech Wallet

Редакция от 01.01.2024

1. ОБЩИЕ ПОЛОЖЕНИЯ

1.1. Настоящее Пользовательское соглашение (далее — Соглашение) 
регулирует отношения между ОсОО «ФВА Финанс» (далее — Компания) 
и пользователем сервиса PolyTech Wallet (далее — Пользователь).

1.2. Использование сервиса означает полное и безоговорочное 
принятие условий настоящего Соглашения.

2. ОПИСАНИЕ СЕРВИСА

2.1. PolyTech Wallet — сервис для:
- Покупки и продажи валюты (USD, EUR, RUB и др.)
- Обмена фиатных валют на виртуальные активы и обратно
- Обмена между фиатными валютами (KGS, RUB, USD, EUR, MDL, KZT)
- Хранения виртуальных активов и фиатных валют

3. РЕГИСТРАЦИЯ И БЕЗОПАСНОСТЬ

3.1. Для использования сервиса необходима регистрация через 
Telegram-бот или веб-интерфейс.

3.2. Пользователь обязан:
- Предоставить достоверные данные
- Не передавать доступ к аккаунту третьим лицам
- Использовать надёжный PIN-код

4. КОМИССИИ И КУРСЫ

4.1. Комиссия за обмен валют: 1.5%
4.2. Курсы обмена получены из официальных источников:
    - ЦБ РФ, НБКР, БНМ, НБРК - для фиатных валют
    - CoinGecko - для курсов валют
4.3. Курсы обновляются каждые 30 минут.

5. ЛИМИТЫ

5.1. Минимальная сумма операции: 100 RUB / 10 MDL
5.2. Лимиты могут быть изменены после прохождения верификации.

6. ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ

6.1. Компания не несёт ответственности за:
- Убытки, связанные с волатильностью курсов
- Задержки по вине платёжных систем
- Действия третьих лиц

7. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ

7.1. Компания вправе изменять условия Соглашения с уведомлением 
Пользователей за 7 дней.

7.2. Споры разрешаются путём переговоров или в судебном порядке 
по законодательству Кыргызской Республики.

Дата публикации: 01.01.2024
ОсОО «ФВА Финанс»
    `
  },
  {
    id: 'privacy',
    title: 'Политика конфиденциальности',
    icon: <Lock size={24} />,
    content: `
ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ
сервиса PolyTech Wallet

Редакция от 01.01.2024

1. ОБЩИЕ ПОЛОЖЕНИЯ

1.1. Настоящая Политика определяет порядок обработки и защиты 
персональных данных Пользователей сервиса PolyTech Wallet.

1.2. Оператор персональных данных: ОсОО «ФВА Финанс»
     ИНН: 01111201510129

2. СОБИРАЕМЫЕ ДАННЫЕ

2.1. Мы собираем следующие данные:
- Telegram ID и имя пользователя
- Номер телефона (при верификации)
- Документы, удостоверяющие личность (при KYC)
- Данные о транзакциях
- IP-адрес и данные устройства

3. ЦЕЛИ ОБРАБОТКИ

3.1. Персональные данные обрабатываются для:
- Предоставления услуг сервиса
- Идентификации Пользователя
- Выполнения требований законодательства (AML/KYC)
- Связи с Пользователем
- Улучшения качества сервиса

4. ЗАЩИТА ДАННЫХ

4.1. Мы применяем следующие меры защиты:
- Шифрование данных при передаче (TLS/SSL)
- Шифрование данных при хранении
- Ограничение доступа сотрудников
- Регулярный аудит безопасности

5. ПЕРЕДАЧА ДАННЫХ

5.1. Мы можем передавать данные:
- Платёжным провайдерам для проведения операций
- Государственным органам по законному требованию
- Подрядчикам под NDA для технической поддержки

5.2. Мы НЕ продаём персональные данные третьим лицам.

6. ХРАНЕНИЕ ДАННЫХ

6.1. Данные хранятся в течение срока использования сервиса 
и 5 лет после его прекращения (требование AML).

7. ПРАВА ПОЛЬЗОВАТЕЛЯ

7.1. Пользователь имеет право:
- Получить информацию о своих данных
- Потребовать исправления неточных данных
- Потребовать удаления данных (с учётом законодательных ограничений)

8. КОНТАКТЫ

8.1. По вопросам персональных данных: support@polytechex.com
8.2. Телефон: +996 507 210 992

Дата публикации: 01.01.2024
ОсОО «ФВА Финанс»
    `
  },
  {
    id: 'extract',
    title: 'Реквизиты компании',
    icon: <FileText size={24} />,
    content: `
КАРТОЧКА ПРЕДПРИЯТИЯ
ОсОО «ФВА Финанс»

ОСНОВНЫЕ СВЕДЕНИЯ:

1. Полное наименование: 
   Общество с ограниченной ответственностью «ФВА Финанс»

2. Сокращённое наименование: ОсОО «ФВА Финанс»

3. Регистрационный номер: 150744-3301-000

4. ИНН: 01111201510129

5. ОКПО: 29284076

6. Юридический адрес:
   720001, Кыргызская Республика, г. Бишкек, 
   Первомайский район, ул. Токтогула, 87A

7. Фактический адрес:
   720044, Кыргызская Республика, г. Бишкек, 
   Ленинский район, ул. Толомуша Океева, 39/5, кв. 27

8. Руководитель: 
   Директор - Уткина Екатерина Алексеевна

9. Контакты:
   Телефон: +996 507 210 992
   Email: support@polytechex.com
   Сайт: fva-finance.com

БАНКОВСКИЕ РЕКВИЗИТЫ:

Банк 1: ОАО «Айыл Банк»
  Р/с (мультивалютный): 1350100020221904
  БИК: 135001

Банк 2: ОАО «ФинансКредитБанк»
  Р/с (мультивалютный): 1340000088397303
  БИК: 134001

Банк 3: Филиал ОАО «Керемет Банк»
  Р/с (мультивалютный): 1360370019060487
  БИК: 136001

ЛИЦЕНЗИИ:

1. Лицензия № 159 на брокерскую деятельность
   Дата выдачи: 16.03.2017, бессрочная

2. Лицензия № 160 на дилерскую деятельность
   Дата выдачи: 16.03.2017, бессрочная

Статус юридического лица: ДЕЙСТВУЮЩЕЕ
    `
  },
  {
    id: 'refund',
    title: 'Политика возврата средств',
    icon: <Scale size={24} />,
    content: `
ПОЛИТИКА ВОЗВРАТА СРЕДСТВ
ОсОО «ФВА Финанс»

Редакция от 01.01.2024

1. ОБЩИЕ ПОЛОЖЕНИЯ

1.1. Настоящая Политика определяет условия и порядок возврата денежных 
средств пользователям сервиса PolyTech Wallet.

1.2. Возврат средств осуществляется в соответствии с законодательством 
Кыргызской Республики и настоящей Политикой.

2. УСЛОВИЯ ВОЗВРАТА

2.1. Возврат средств возможен в следующих случаях:
- Ошибочное зачисление средств на счёт
- Технический сбой при проведении операции
- Отмена операции до её исполнения
- По решению службы поддержки

2.2. Возврат НЕ осуществляется в случаях:
- Успешно завершённых операций обмена валют
- Операций, проведённых с нарушением Пользовательского соглашения
- При выявлении мошеннических действий
- После истечения 30 дней с момента операции

3. ПОРЯДОК ПОДАЧИ ЗАЯВКИ НА ВОЗВРАТ

3.1. Для возврата средств необходимо:
- Обратиться в службу поддержки через Telegram или Email
- Указать номер транзакции или ID операции
- Описать причину возврата
- Предоставить подтверждающие документы (при необходимости)

3.2. Контакты для обращения:
- Email: support@polytechex.com
- Telegram: @PolyTechSupport
- Телефон: +996 507 210 992

4. СРОКИ РАССМОТРЕНИЯ И ВОЗВРАТА

4.1. Заявка на возврат рассматривается в течение 5 рабочих дней.

4.2. При положительном решении возврат осуществляется:
- На банковскую карту: 3-14 рабочих дней
- На электронный кошелёк: 1-3 рабочих дня
- На валютный счёт: 1-24 часа

4.3. Возврат производится тем же способом, которым был осуществлён платёж.

5. КОМИССИИ ПРИ ВОЗВРАТЕ

5.1. Комиссия за возврат:
- При ошибке со стороны сервиса: 0%
- По инициативе пользователя: может взиматься комиссия платёжной системы

6. СПОРНЫЕ СИТУАЦИИ

6.1. В случае спора пользователь может обратиться:
- В службу поддержки компании
- В Государственную службу регулирования и надзора за финансовым рынком КР
- В судебные органы Кыргызской Республики

Дата публикации: 01.01.2024
ОсОО «ФВА Финанс»
ИНН: 01111201510129
    `
  }
];

const DocumentsPage = () => {
  const [selectedDoc, setSelectedDoc] = useState(null);

  if (selectedDoc) {
    const doc = documents.find(d => d.id === selectedDoc);
    return (
      <div className="min-h-screen" style={{ background: COLORS.bg }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
          <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
            <button 
              onClick={() => setSelectedDoc(null)}
              className="p-2 rounded-xl hover:bg-gray-100 transition"
            >
              <ArrowLeft size={24} style={{ color: COLORS.dark }} />
            </button>
            <h1 className="font-semibold text-lg" style={{ color: COLORS.dark }}>
              {doc.title}
            </h1>
          </div>
        </header>

        {/* Document Content */}
        <div className="max-w-4xl mx-auto px-4 py-8">
          <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8">
            <div className="flex items-center gap-4 mb-6 pb-6 border-b border-gray-100">
              <div 
                className="w-14 h-14 rounded-xl flex items-center justify-center"
                style={{ background: `${COLORS.primary}15`, color: COLORS.primary }}
              >
                {doc.icon}
              </div>
              <div>
                <h2 className="font-bold text-xl" style={{ color: COLORS.dark }}>{doc.title}</h2>
                <p className="text-sm" style={{ color: COLORS.gray }}>ОсОО «ФВА Финанс»</p>
              </div>
            </div>
            
            <pre 
              className="whitespace-pre-wrap font-sans text-sm leading-relaxed"
              style={{ color: COLORS.dark }}
            >
              {doc.content}
            </pre>
          </div>

          <div className="mt-6 text-center">
            <button
              onClick={() => {
                const blob = new Blob([doc.content], { type: 'text/plain;charset=utf-8' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${doc.title}.txt`;
                a.click();
                URL.revokeObjectURL(url);
              }}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl font-medium text-white transition hover:opacity-90"
              style={{ background: COLORS.primary }}
            >
              <Download size={20} />
              Скачать документ
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{ background: COLORS.bg }}>
      {/* Header */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-3">
            <img src="/polytech-logo.png" alt="PolyTech Wallet" className="w-10 h-10 rounded-xl" />
            <span className="font-bold text-xl" style={{ color: COLORS.dark }}>PolyTech Wallet</span>
          </a>
          <a 
            href="/"
            className="text-sm font-medium hover:text-green-600 transition"
            style={{ color: COLORS.gray }}
          >
            ← На главную
          </a>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: COLORS.dark }}>
            Юридические документы
          </h1>
          <p className="text-lg" style={{ color: COLORS.gray }}>
            Мы работаем в соответствии с законодательством Кыргызской Республики
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {documents.map((doc, i) => (
            <motion.button
              key={doc.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              onClick={() => {
                if (doc.isPdf && LICENSE_PDFS[doc.id]) {
                  window.open(LICENSE_PDFS[doc.id], '_blank');
                } else {
                  setSelectedDoc(doc.id);
                }
              }}
              className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition text-left group"
            >
              <div 
                className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ background: `${COLORS.primary}15`, color: COLORS.primary }}
              >
                {doc.icon}
              </div>
              <div className="flex-1">
                <h3 className="font-semibold mb-1 group-hover:text-green-600 transition" style={{ color: COLORS.dark }}>
                  {doc.title}
                </h3>
                <p className="text-sm" style={{ color: COLORS.gray }}>
                  {doc.isPdf ? 'Открыть PDF документ' : 'Нажмите для просмотра'}
                </p>
              </div>
            </motion.button>
          ))}
        </div>

        <div className="mt-12 p-6 rounded-2xl text-center" style={{ background: `${COLORS.primary}10` }}>
          <p className="text-sm" style={{ color: COLORS.dark }}>
            <strong>ОсОО «ФВА Финанс»</strong> — лицензированный брокер и дилер на рынке ценных бумаг Кыргызской Республики.
            <br />
            Лицензии № 159, № 160 | ИНН: 01111201510129 | Тел: +996 507 210 992
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="mt-auto py-8 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-sm" style={{ color: COLORS.gray }}>
            © 2024-2026 ОсОО «ФВА Финанс». Все права защищены.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default DocumentsPage;
